<template>
  <div class="home">
    <el-container>
      <el-header>
        <Header></Header>
      </el-header>
      <el-container class="content">
        <!-- <el-aside width="200px">
          <Menu></Menu>
        </el-aside> -->
        <el-container>
          <!-- <Bread class="Bread"></Bread> -->
          <el-main class="main">
            <router-view></router-view>
          </el-main>
          <!-- <el-footer> -->
            <!-- <Footer></Footer> -->
          <!-- </el-footer> -->
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
// import Footer from "./components/Footer.vue";
// import Menu from "./components/Menu.vue";
// import Bread from "./components/Breadcrumb.vue";
export default {
  components: {
    Header,
    // Footer,
    // Menu,
    // Bread,
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  padding-left: 2px;
  width: 15px;
  height: 10px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #409eff;
}

::-webkit-scrollbar-track {
  border-radius: 5px;
  background-color: #f5f5f5;
}

.home {
  width: 100%;
  height: 100%;
  .content {
    margin-top: 60px;
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    .el-header,
    .el-footer {
      padding: 0;
    }
    .el-aside{
      background: #409eff;
      text-align: center;
    }
    .main {
      background: #fff;
    }
    // .Bread{
    //   margin: 20px;
    // }
  }
}
</style>